// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4450":"ad5783e0","5224":"7360a0b5"}[chunkId] + ".chunk.css";
};